import React, { FC } from "react";
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

//reference: https://mui.com/components/tooltips/#customization
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    fontFamily: "'Eloquia Text', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    border: "1px solid #333333",
    borderRadius: "4px",
    boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.1)",
    maxWidth: "239px",
  },
}));

interface HintProps extends TooltipProps {}

const Hint: FC<HintProps> = ({ ...props }) => {
  return (
    <HtmlTooltip
      title={
        props.title ? (
          <p className="p-16 body2 text-white">{props.title}</p>
        ) : (
          ""
        )
      }
      followCursor={props.followCursor ? props.followCursor : false}
    >
      <span>{props.children}</span>
    </HtmlTooltip>
  );
};

export default Hint;
